import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

// console.log = () => {}
// console.error = () => {}
// console.debug = () => {}

ReactDOM.render(<App />, document.getElementById('root'))
